import { Provider } from '@angular/core';

import { TourUseCasesImpl } from '@app/domain/use-cases/tour/tour.use-cases';
import { TOUR_USE_CASES } from '@app/domain/use-cases/tour/tour.use-cases.contract';

export const tourUseCasesProvider: Provider = {
  provide: TOUR_USE_CASES,
  useClass: TourUseCasesImpl
};
